import * as React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router';
import { Form, Row, Col, Input, Icon, Select, Button, Checkbox, Collapse, Skeleton } from 'antd';
import FormControl from 'components/Forms/FormControl';
import FormUtility from 'Core/FormUtility';
import ValidationUtility from 'Core/ValidationUtility';
import MaskedInput from 'components/Forms/MaskedInput';
import { CreditCardRegistrationFormHandler } from 'components/UserManagement/Profile/CreditCardRegistrationForm/CreditCardRegistrationFormHandler';
import {
  IReferenceValueDto,
  CreditCardRegistrationDto,
  ExecuteBillOfLadingPaymentRequest,
  CreditCardPaymentMethodDto,
  BillOfLadingDto,
  BillOfLadingChargeDto,
  BillOfLadingData,
  BeginBillPaymentRequest,
  ICreditCardRegistrationDto,
} from 'Core/Api/Payment/Api';
import {
  PageContainerRow,
  PageContainerCol,
  PageContainerColLayout,
} from 'components/CartManagement/CartOverviewView/CartOverviewView.Style';
import { PageTitle } from 'components/Styled/Layout.Styled';
import CheckoutCardImage from 'assets/images/creditcardcheckout.png';
import VerifiedByImage from 'assets/images/vbv_mcsc_logo.png';
import { AuthUser } from 'Core/models/AuthUser';
import CartContext from 'Context/CartContext';
import moment from 'moment';
import { CargoChargesHandler } from 'components/CargoCharges/CargoChargesForm/CargoChargesFormHandler';
import { CargesModel } from 'components/CargoCharges/CargoChargesResults/CargoChargesResultsModel';
import { CheckoutHandler } from './CheckoutHandler';
import TermsAndConditionLink from 'components/Forms/TermsAndConditionLink';
import Utility from 'Core/Utility';
import { LOGROCKET_IGNORE_CLASS } from 'components/LogRocketErrorMonitor/LogRocketErrorMonitor';
import { FaCcVisa, FaCcMastercard, FaCreditCard } from 'react-icons/fa';


export type SelectedCard = { card?: ICreditCardRegistrationDto, cvv: string, isAuthorize: boolean };

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
  user?: AuthUser;
  confirmedCards?: ICreditCardRegistrationDto[];
  onCardDetailsChanged?: (selectedCard: SelectedCard) => void;
  updateHack?: number;
}

export interface State {
  cardCurrencies?: IReferenceValueDto[];
}

export class CardSelectFormWithoutRouterAndForm extends React.Component<Props, State> {
  static contextType = CartContext;
  context!: React.ContextType<typeof CartContext>;

  constructor(props: Props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);

    this.state = {
    };
  }

  public RaiseValidation = (): PromiseLike<any> => {
    return new Promise(x => {
      this.props.form.validateFields((error, values) => {

        Promise.resolve(error);
      })
    }
    )
  }

  componentDidUpdate = (prevProps: Props) => {
    if (prevProps.updateHack != this.props.updateHack) {
      this.props.form.validateFieldsAndScroll();
    }
  }

  checkBoxChanged = () => {
    let me = this;
    this.props.form.validateFieldsAndScroll((errors, values) => {
      me.formChanged();
    });
  }

  formChanged = () => {
    let values = this.props.form.getFieldsValue();
    let card = !!values.cardId ? this.props.confirmedCards?.filter(x => x.id == values.cardId)[0] : undefined;
    let selectedCard: SelectedCard = { card: card, cvv: values.cvv, isAuthorize: values.termsCon };
    this.props.onCardDetailsChanged?.call(this, selectedCard);
  }

  onFormSubmit(event: React.FormEvent) {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((error, values: CreditCardPaymentMethodDto) => {
      if (!error) {
        // set expiry month & year
        //this.props.onCardDetailsEntered?.call(this, undefined, null);

      }
    });
  }

  renderCardImage(cardFirstDigits?: string) {
    if (cardFirstDigits?.startsWith("4")) {
      return <FaCcVisa />;
    }

    if (cardFirstDigits?.startsWith("5")) {
      return <FaCcMastercard />
    } else {
      return <FaCreditCard />
    }
  }

  render() {
    const { form } = this.props;
    const getFieldDecorator = form.getFieldDecorator;
    const { Option } = Select;
    const cards = this.props.confirmedCards?.filter(x => x.wasSaved) ?? [];

    return (
      <Skeleton active loading={!this.props.confirmedCards}>
        <PageContainerRow style={{ textAlign: 'center' }}>

          <PageContainerCol {...PageContainerColLayout}>
            {/* <Form onSubmit={this.onFormSubmit} layout='vertical'> */}
            <Form onBlur={this.formChanged} layout="vertical" className={LOGROCKET_IGNORE_CLASS} onSubmit={this.onFormSubmit}>
              {/* Credit  Card Type*/}
              <Row gutter={10} type="flex" align="top">
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 16 }}
                  lg={{ span: 16 }}
                  xl={{ span: 16 }}>
                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[...ValidationUtility.getRequired('Please select a Credit Card')]}
                    name="cardId"
                    label="Card">
                    <Select allowClear={true} onChange={this.formChanged} onBlur={this.formChanged} optionLabelProp="title" >
                      {cards.map(card => (
                        <Option key={card.id} value={card.id} title={`${card.cardNumberFirstFourDigits} XXXX XXXX ${card.cardNumberLastFourDigits}`}>
                          <Row>
                            <Col span={3}>
                              {this.renderCardImage(card.cardNumberFirstFourDigits)}
                            </Col>
                            <Col>{card.cardNumberFirstFourDigits} XXXX XXXX {card.cardNumberLastFourDigits}</Col>
                          </Row>
                        </Option>
                      ))}
                    </Select>
                  </FormControl>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 8 }}>
                  <FormControl

                    getFieldDecorator={getFieldDecorator}
                    rules={[
                      ...ValidationUtility.getRequired('Please enter CVV2 Number'),
                      ...ValidationUtility.getPattern(
                        /^[0-9]{3}/,
                        'Please enter valid CVV2 Number'
                      ),
                    ]}
                    name="cvv"
                    label="CVV2/CVC2">
                    <Input.Password
                      visibilityToggle={true}
                      onChange={this.formChanged}
                      onBlur={this.formChanged}
                      type="password"
                    />
                  </FormControl>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    name="termsCon"
                    valuePropName="checked"
                    initialValue={false}
                    rules={[
                      ...ValidationUtility.getCheckBoxChecked(
                        'Please confirm that you are authorised to use this card'
                      ),
                    ]}>

                    <Checkbox onClick={this.checkBoxChanged}> I confirm that I am authorized to use this card.</Checkbox>
                  </FormControl>
                </Col>
              </Row>
            </Form>
          </PageContainerCol>
        </PageContainerRow>
      </Skeleton>
    );
  }

  private ShowCardRegistartionError() {
    this.props.form.setFields({
      'cardDetails.cardNumber': {
        errors: [new Error('Can only use cards that have been registered and confirmed')],
      },
    });
  }
}

const CardSelectFormWithoutRouter = Form.create<Props>({
  name: 'Checkout',
})(CardSelectFormWithoutRouterAndForm);

const CardSelectForm = withRouter(CardSelectFormWithoutRouter);

export default CardSelectForm;
